import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import '../ghs-icon/ghs-icon';
import '../../base/outline-heading/outline-heading';
import componentStyles from './ghs-step.css.lit';

/**
 * The step component.
 * @element ghs-step
 * @slot - The default slot.
 */

@customElement('ghs-step')
export class GhsStep extends OutlineElement {
  static styles = [componentStyles];
  /**
   * Whether or not the component should be 100% height of its parent.
   * If TRUE, the Host will be `height: 100%`.
   */
  @property({ type: Boolean, attribute: 'height-grow', reflect: true })
  heightGrow = true;
  /**
   * The step number.
   */
  @property({ type: Number }) number: number;
  /**
   * The heading text.
   */
  @property({ type: String }) heading: string;

  render(): TemplateResult {
    return html`
      <div class="ghs-step">
        <p class="step-number">${this.number}</p>
        <p class="step-heading">${this.heading}</p>
        <div class="step-content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
